




























import SfButton from "~/themes/fiskarsMoominDefault/components/components/atoms/SfButton/SfButton.vue";
export default {
  name: "CartEmptyState",
  components: {SfButton},
  props: {
    title: String,
    subtitle: String,
    image: Object,
    contentText: String,
    buttonText: String,
    buttonUrl: String
  },
  setup() {
  }
}
